import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { ProgramsPage } from './pages/ProgramsPage';
import { WorkshopsPage } from './pages/WorkshopsPage';
import { ResourcesPage } from './pages/ResourcesPage';
import { ArticlePage } from './pages/ArticlePage';
import { VideoCoursePage } from './pages/VideoCoursePage';
import { FAQPage } from './pages/FAQPage';
import { ContactPage } from './pages/ContactPage';
export function App() {
  return <HashRouter data-id="element-0">
      <Layout data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<HomePage data-id="element-4" />} data-id="element-3" />
          <Route path="/about" element={<AboutPage data-id="element-6" />} data-id="element-5" />
          <Route path="/programs" element={<ProgramsPage data-id="element-8" />} data-id="element-7" />
          <Route path="/video-course" element={<VideoCoursePage data-id="element-10" />} data-id="element-9" />
          <Route path="/workshops" element={<WorkshopsPage data-id="element-12" />} data-id="element-11" />
          <Route path="/resources" element={<ResourcesPage data-id="element-14" />} data-id="element-13" />
          <Route path="/resources/:slug" element={<ArticlePage data-id="element-16" />} data-id="element-15" />
          <Route path="/faq" element={<FAQPage data-id="element-18" />} data-id="element-17" />
          <Route path="/contact" element={<ContactPage data-id="element-20" />} data-id="element-19" />
        </Routes>
      </Layout>
    </HashRouter>;
}